import type { GradingId } from "@repo/app-types/entities/teammatePerformanceSummary";
import {
  SlideoverDialog,
  SlideoverDialogContentGray,
  SlideoverDialogTitleHeader,
} from "@repo/ui/Slideover/slideoverDialog";
import type { FC } from "react";
import { useState } from "react";
import { usePlaybookGradingQuery } from "../../api/entities/performancePlaybook.js";
import { KnowledgeBaseAdherenceStatementSlideoverDialog } from "./knowledgeBaseAdherenceStatementSlideoverDialog.js";
import { ShareKnowledgeBaseAdherenceFindingModal } from "./shareKnowledgeBaseAdherenceFindingModal.js";

interface KnowledgeBaseAdherenceStatementSlideoverDialogContainerProps {
  gradingId: GradingId;
  statementId: string;
}

export const KnowledgeBaseAdherenceStatementSlideoverDialogContainer: FC<
  KnowledgeBaseAdherenceStatementSlideoverDialogContainerProps
> = ({ gradingId, statementId }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const { data: grading, isLoading } = usePlaybookGradingQuery({ gradingId });

  const statementIndex = Number(statementId);
  const statement =
    Number.isInteger(statementIndex) && statementIndex >= 0
      ? grading?.knowledge_base_adherence?.statements.at(statementIndex)
      : undefined;

  if (!statement || !grading) {
    return (
      <SlideoverDialog label="Knowledge base adherence finding">
        <SlideoverDialogTitleHeader isLoading={isLoading}>
          Knowledge base adherence finding
        </SlideoverDialogTitleHeader>
        <SlideoverDialogContentGray>
          {!isLoading ? (
            <div className="p-4 text-sm text-muted-foreground">
              Finding not found.
            </div>
          ) : null}
        </SlideoverDialogContentGray>
      </SlideoverDialog>
    );
  }

  return (
    <>
      <KnowledgeBaseAdherenceStatementSlideoverDialog
        gradingId={grading.id}
        statementIndex={statementIndex}
        recordings={grading.recordings}
        statement={statement}
        onSharePress={() => setIsShareModalOpen(true)}
      />

      <ShareKnowledgeBaseAdherenceFindingModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        grading={grading}
        statement={statement}
        statementId={statementId}
      />
    </>
  );
};
